import { Tooltip } from "@material-ui/core";
import * as React from "react";
import MaterialHelpIcon from "@material-ui/icons/Help";

type HelpIconProps = {
  tooltip?: string;
};

function HelpIcon({ tooltip }: HelpIconProps) {
  return (
    <Tooltip title={tooltip || ""}>
      <span>
        <MaterialHelpIcon color="primary" />
      </span>
    </Tooltip>
  );
}

export default HelpIcon;
